export class FlipbookCollections {
  public index: number;
  public sku: string;

  constructor(index: number, sku: string) {
    this.index = index;
    this.sku = sku;
  }
}
